import config from "../config";

const TEAMS_BOT_PATH = "/bots/teams/messages";

/** Horizon server that receives Teams bot traffic for each product host. */
const TEAMS_MESSAGING_HOSTS: Record<string, string> = {
  "runtheo.app": "https://api.runtheo.app",
  "www.runtheo.app": "https://api.runtheo.app",
  "api.runtheo.app": "https://api.runtheo.app",
  "dev.runtheo.app": "https://neo-horizon-server-653743782340.us-central1.run.app",
  "demo.runtheo.app": "https://neo-horizon-server-732384755797.us-central1.run.app",
  "sandbox.runtheo.app": "https://neo-horizon-server-1032003241184.us-central1.run.app",
};

export function teamsMessagingEndpoint(hostname?: string, apiUrl?: string): string {
  const host = String(hostname ?? (typeof window !== "undefined" ? window.location.hostname : ""))
    .trim()
    .toLowerCase();
  const mapped = TEAMS_MESSAGING_HOSTS[host];
  const base = String(mapped || apiUrl || config.apiUrl || "")
    .trim()
    .replace(/\/+$/, "");
  return base ? `${base}${TEAMS_BOT_PATH}` : `https://<horizon-server>${TEAMS_BOT_PATH}`;
}
